// MAIN
import mainReducerParts from './Main/reducerParts';
import { initialState as mainInitialState } from './Main/initialState';

// ChartsSettings
import chartsSettingsReducerParts from './slices/ChartsSettings/reducerParts';
import { initialState as chartsSettingsInitialState } from './slices/ChartsSettings/initialState';

// ChartsBelowCriterions
import chartsBelowCriterionsReducerParts from './slices/ChartsBelowCriterions/reducerParts';
import { initialState as chartsBelowCriterionsInitialState } from './slices/ChartsBelowCriterions/initialState';

// ChartsRemediations
import chartsRemediationsReducerParts from './slices/ChartsRemediations/reducerParts';
import { initialState as chartsRemediationsInitialState } from './slices/ChartsRemediations/initialState';

// ActionPlanChangeNotesV2
import actionPlanChangeNotesV2ReducerParts from './slices/ActionPlanChangeNotesV2/reducerParts';
import { initialState as actionPlanChangeNotesV2InitialState } from './slices/ActionPlanChangeNotesV2/initialState';

export const initialState = {
	...actionPlanChangeNotesV2InitialState,
	...chartsRemediationsInitialState,
	...chartsBelowCriterionsInitialState,
	...chartsSettingsInitialState,
	...mainInitialState
};

export const reducerParts = {
	...actionPlanChangeNotesV2ReducerParts,
	...chartsRemediationsReducerParts,
	...chartsBelowCriterionsReducerParts,
	...chartsSettingsReducerParts,
	...mainReducerParts
};

export default {
	initialState,
	reducerParts
};
